
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCursorNotAllowedIcon as ObiCursorNotAllowedIconElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cursor-not-allowed-icon.js';
 
 
 

 
 export const ObiCursorNotAllowedIcon = createComponent({
   react: React,
   tagName: 'obi-cursor-not-allowed-icon',
   elementClass: ObiCursorNotAllowedIconElement,
   events: {
     
   }
  });
 
 